import { render, staticRenderFns } from "./person_data_set.vue?vue&type=template&id=de6ce45c&scoped=true"
import script from "./person_data_set.vue?vue&type=script&lang=js"
export * from "./person_data_set.vue?vue&type=script&lang=js"
import style0 from "./person_data_set.vue?vue&type=style&index=0&id=de6ce45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6ce45c",
  null
  
)

export default component.exports